module.exports = __webpack_public_path__ + "img/app-dl-badge_google-play.ad4de182.png";